import script from "./KnowlegeEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./KnowlegeEdit.vue?vue&type=script&setup=true&lang=ts"

import "./KnowlegeEdit.vue?vue&type=style&index=0&id=607ae079&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-607ae079"]])

export default __exports__